import { StanCard, StanSimpleBarChart } from '@/components';
import { useChartData } from '../queries/useAnalyticsQueries';
import { CHART_TYPES, type TrafficSourcesChartProps } from '../types/analytics.types';
import { calculateAnalyticsRange, calculatePeriodLength, getEndDateTimestamp } from '../logic/analytics.logic';
import { ANALYTICS_COLORS, ANALYTICS_DEFAULTS } from '../constants/analytics.constants';

export function TrafficSourcesChart({ dateRange }: TrafficSourcesChartProps) {
    const analyticsRange = calculateAnalyticsRange(dateRange);
    const endDateTimestamp = getEndDateTimestamp(dateRange.endDate);
    const periodLength = calculatePeriodLength(analyticsRange);

    const { data, isLoading } = useChartData(
        CHART_TYPES.TRAFFIC_SOURCES,
        analyticsRange,
        endDateTimestamp,
        periodLength,
        true
    );

    return (
        <StanCard className='flex h-full flex-col gap-6'>
            <h3>Where are my customers from?</h3>
            <div className='w-full'>
                <StanSimpleBarChart
                    totals={data?.totals ?? {}}
                    showTopN={ANALYTICS_DEFAULTS.TOP_N_ITEMS}
                    otherLabel='Direct'
                    color={ANALYTICS_COLORS.TRAFFIC}
                    loading={isLoading}
                />
            </div>
        </StanCard>
    );
}
